import styled from 'styled-components';
import React, { useContext } from 'react';

import AuthContext from './store/auth-context';

import Layout from './components/Layout/Layout'
import Store from "./containers/Store/Store";
import ProductDetails from "./containers/ProductDetails/ProductDetails";
import Cart from "./containers/Cart/Cart";
import Orders from "./containers/Orders/Orders";
import Checkout from "./containers/Checkout/Checkout";
import Auth from './containers/Auth/Auth';


import { Route , Switch , withRouter , Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Logout from './containers/Auth/Logout/Logout';


const AppWrapper = styled.div`
  text-align: center;
  background-color: ${props => props.theme.palette.background.default};
  min-height: 100vh;
  width: 100%;
`

const  App =  props => {

  const authCtx = useContext(AuthContext);


  let routes = (
      // Routes For Unauth users
      <Switch>
          <Route path='/auth' component={Auth} />
          <Route path='/:id' component={ProductDetails} />
          <Route path='/' component={Store} />
          <Redirect to='/' />
      </Switch>
    )
    if (authCtx.isLoggedIn) {
      routes = (
        // Routes For Auth users [ Auth - Logout ]
        <Switch>
          <Route path='/logout' component={Logout} />
          <Route path='/checkout' component={Checkout} />
          <Route path='/orders' component={Orders} />
          <Route path='/cart' component={Cart} />
          <Route path='/:id' component={ProductDetails} />
          <Route path='/' component={Store} />
          <Redirect to='/' />
        </Switch>
      )
    }
  return (
    <AppWrapper >
        <Layout>
            { routes }
        </Layout>
    </AppWrapper>
  )
}
const mapStateToProps = state => {
  return {
    authenticated: true,
  }
}


export default withRouter(connect( mapStateToProps , null )(App));
